import { Button } from "@heroui/react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";

interface ChatFABProps {
  isOpen: boolean;
  onPress: () => void;
}

export function ChatFAB({ isOpen, onPress }: ChatFABProps) {
  return (
    <Button
      isIconOnly
      onPress={onPress}
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 min-w-0 rounded-full bg-[#215273] text-white shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
      aria-label={isOpen ? "Close chat" : "Open chat"}
    >
      <div className="transition-transform duration-200">
        {isOpen ? (
          <CloseIcon fontSize="medium" />
        ) : (
          <ChatBubbleOutlineIcon fontSize="medium" />
        )}
      </div>
    </Button>
  );
}
